import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const QualityControlPage = lazy(
  () => import('@/pages/quality-control/ui/index'),
)

export const Route = createFileRoute('/_protected/expedition/quality-control')({
  component: () => (
    <Suspense fallback={<Loader />}>
      <QualityControlPage />
    </Suspense>
  ),
})
